import React, {Component, Fragment} from 'react';
import Lightbox from 'react-images';
import {Icon} from '..//Icon';
import cx from '../../../styles';
import { gtmSend } from '../../../helpers';

class ImageLightbox extends Component {

    constructor(props) {
        super(props);
        this.state = {photoIndex: 0, isOpen: false, isPlayGif: false};
    }

    handleClick = () => {
        gtmSend('dynamic', `Gif play button`, 'click', 'gif');

        if(!this.state.isPlayGif) {
            this.setState({
                isPlayGif: true
            })
        }
    }
    
    render() {
        const {photoIndex, isOpen} = this.state;
        const images = this.props.images.map((img) => {
            return {src: img.image}
        });
        const type = this.props.type || '';

        return (
            <Fragment>
                {
                    type === 'gif'
                    ?
                        this.state.isPlayGif
                        ? 
                            <img className={cx("pointer-click")} 
                                src={this.props.images[0].image} 
                                loading="eager"
                                height={this.props.images[0].height}
                                width={this.props.images[0].width}
                                alt={this.props.imageAltText ? this.props.imageAltText : 'Post image'} 
                                onClick={()=>this.setState({isOpen: true})} />
                        :
                            <span className={cx("gif-wrap")} onClick={() => this.handleClick()}>
                                <img
                                    src={this.props.images[0].thumbnail} 
                                    loading="lazy"
                                    height={this.props.images[0].thumb_height}
                                    width={this.props.images[0].thumb_width}
                                    alt={this.props.imageAltText ? this.props.imageAltText : 'Post image'} 
                                     />
                                {!this.state.isPlayGif && <span className={cx("play-button")}>GIF</span>}
                            </span>
                    :
                        <img className={cx("pointer-click")} 
                            src={this.props.images[0].thumbnail} 
                            loading="lazy"
                            height={this.props.images[0].thumb_height}
                            width={this.props.images[0].thumb_width}
                            alt={this.props.imageAltText ? this.props.imageAltText : 'Post image'} 
                            onClick={()=>this.setState({isOpen: true})} />
                }

                {
                    images.length > 1
                    ?
                        <span className={cx("more-image-wrap")} onClick={()=>this.setState({isOpen: true})}>
                            <Icon name="images-regular-white-md" />
                        </span>
                    :
                        ""
                }

                <Lightbox
                    isOpen={isOpen}
                    images={images}
                    currentImage={photoIndex}
                    onClose={()=> this.setState({isOpen: false})}
                    onClickNext={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % images.length
                        })
                    }
                    onClickPrev={() =>
                        this.setState({
                            photoIndex: (photoIndex + images.length - 1) % images.length                            
                        })
                    }
                />
            </Fragment>
        );
    }

}

export default ImageLightbox;
